var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parle"},[_vm._v(" PARLE "),_c('BreadCrumb'),_c('ParleList'),_c('ParleSend')],1)}
var staticRenderFns = []

export { render, staticRenderFns }